import { render } from "./DisplayCollectionItems.vue?vue&type=template&id=50f3bd5e&scoped=true"
import script from "./DisplayCollectionItems.vue?vue&type=script&lang=js"
export * from "./DisplayCollectionItems.vue?vue&type=script&lang=js"

import "./DisplayCollectionItems.vue?vue&type=style&index=0&id=50f3bd5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f3bd5e"]])

export default __exports__